import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { 
  Car, 
  Users, 
  Calendar, 
  DollarSign, 
  Eye, 
  TrendingUp, 
  MapPin, 
  Phone, 
  Globe,
  Building,
  BarChart3,
  Activity,
  Clock,
  Star,
  ArrowUpRight,
  ArrowDownRight,
  ChevronRight,
  Target,
  Zap,
  Award,
  Briefcase,
  MessageSquare,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  CarFront,
  Tags,
  BadgePercent,
  CalendarMinus2,
  GalleryVerticalEnd,
  BadgeCheck,
  UsersRound,
} from 'lucide-react';
import { getDealerAppointments } from './../services/appointment';
import { getDealerDashboard } from './../services/dealer';
import { startOfMonth, endOfMonth, format } from 'date-fns';
import Table from './ui/Table';

const Wrapper = styled.div`
  min-height: 100vh;
  background: #1B1C30;
  color: #ffffff;
  font-family: 'Clash Grotesk', sans-serif;
  overflow-x: hidden;
  position: relative;
  
`;

const Container = styled.div`
  z-index: 1;
  
`;

const HeroSection = styled.div`
margin-bottom: 20px;
`;

const HeroContent = styled.div`
position: relative;
`;

const HeroInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
 align-items: center;
  margin-bottom: 20px;
  
  @media (max-width: 1024px) {
    text-align: left;
     display: block;
  }
`;

const WelcomeTitle = styled.h1`
  font-size: 36px;
  font-weight: 900;
  background: linear-gradient(135deg, #ffffff 0%, #F43F60 50%, #EF4444 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.1;
  letter-spacing: -0.02em;
  
`;

const WelcomeSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.125rem;
  margin: 0 0 16px 0;
  font-weight: 400;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  
  @media (min-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    font-size: 1.25rem;
  }
`;

const DealerBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #F43F60 0%, #EF4444 100%);
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  
`;

const QuickStats = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;
  width: 100%;
  
 @media (min-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  @media (min-width: 1200px) {
    grid-template-columns: repeat(5, 1fr);
     gap: 20px;
  }
  
  /* iPad specific adjustments */
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
  
`;

const QuickStat = styled.div`
  background: #25253C;
  border-radius: 10px;
  padding: 20px 16px;
  text-align: center;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  
  @media (min-width: 768px) {
    padding: 24px 20px;
  }
`;

const CarIcons = styled.div`
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  flex-shrink: 0;
  margin-right: 15px;
`;

const CarCons = styled.div`
  display: block;
  text-align: left;
`;


const QuickStatValue = styled.div`
  font-size: 1.75rem;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.2;
  
  @media (min-width: 640px) {
    font-size: 2rem;
  }
  
  @media (min-width: 1024px) {
    font-size: 2.25rem;
  }
`;

const QuickStatLabel = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  @media (min-width: 640px) {
    font-size: 0.875rem;
  }
`;

const MainGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  /* iPad specific breakpoint */
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
`;

const LargeCard = styled.div`
  border-radius: 10px;
  background: #25253C;
  padding: 15px;
  position: relative;
  overflow: hidden;
  
  @media (min-width: 768px) {
    padding: 15px;
  }
  
  @media (min-width: 1024px) {
    padding: 20px;
  }
`;

const WideCard = styled.div`
  position: relative;
  overflow: hidden;

  @media (min-width: 768px) {
    grid-column: span 2;
  }
  
  /* iPad specific adjustments */
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-column: span 2;
  }

`;

const FullWidthCard = styled.div`
  border-radius: 10px;
  background: #25253C;
  padding: 15px;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  @media (min-width: 768px) {
    padding: 15px;
  }
  
  @media (min-width: 1024px) {
    padding: 20px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  
  @media (min-width: 640px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }
  
  /* iPad specific adjustments */
  @media (min-width: 768px) and (max-width: 1023px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }
`;

const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.50);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  
  @media (min-width: 640px) {
    font-size: 18px;
  }
`;

const CardIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, ${props => props.bgColor || '#667eea'}20, ${props => props.bgColor || '#667eea'}10);
  color: ${props => props.bgColor || '#667eea'};
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
  
  @media (min-width: 640px) {
    width: 36px;
    height: 36px;
  }
`;

const ViewMoreButton = styled.button`
  background: #1E1E35;
  padding: 10px 12px;
  border-radius: 12px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  position: relative;
  overflow: hidden;
  
  &:hover {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%);
    transition: all 0.3s ease;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  
  @media (min-width: 640px) {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 20px;
  }
  
  /* iPad specific adjustments */
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }
`;

const StatItem = styled.div`
  text-align: center;
  padding: 16px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  background: #1E1E35;
  box-shadow: 0 15px 15px 0 rgba(75, 75, 75, 0.08);
 
  
  @media (min-width: 640px) {
    padding: 20px;
  }
`;

const StatValue = styled.div`
  font-size: 1.2rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 6px;
  line-height: 1;  
  margin-top: 18px;
  
  @media (min-width: 640px) {
    font-size: 1.5rem;
  }
`;

const StatLabel = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  @media (min-width: 640px) {
    font-size: 0.875rem;
  }
`;

const VehicleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const VehicleItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #25253C;
  border-radius: 10px;
  position: relative;
  overflow: hidden;

  
  /* iPad specific adjustments */
  @media (min-width: 768px) and (max-width: 1023px) {
    gap: 12px;
    padding: 14px;
  }
  @media (max-width: 575px) {
    display:block
  }
`;

const VehicleImage = styled.div`
  width: 64px;
  height: 48px;
  border-radius: 10px;
  background: #1E1E35;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.75rem;
  flex-shrink: 0;
  overflow: hidden; 
  @media (max-width: 575px) {
    margin-bottom: 10px;
  }
`;

const VehicleInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

const VehicleName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  /* iPad specific adjustments */
  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 16px;
  }
`;

const VehicleDetails = styled.div`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: capitalize;
`;


const Dotss = styled.div`
  margin: 0 6px;
  display: inline-block;
`;


const VehiclePrice = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: #0fc9a7;
  flex-shrink: 0;
  text-align: right;

  @media (max-width: 575px) {
    text-align: left;
    margin-top: 10px;
  }
`;

const ActivityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ActivityItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  border-radius: 10px;
  background: #1E1E35;
  border-left: 4px solid ${props => props.accentColor || '#667eea'};
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;

  /* iPad specific adjustments */
  @media (min-width: 768px) and (max-width: 1023px) {
    gap: 12px;
    padding: 14px;
  }
`;

const ActivityIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, ${props => props.bgColor || '#667eea'}20, ${props => props.bgColor || '#667eea'}10);
  color: ${props => props.bgColor || '#667eea'};
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
  
  @media (min-width: 640px) {
    width: 36px;
    height: 36px;
  }
`;

const ActivityContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const ActivityTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 6px;
`;

const ActivityTime = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
`;

const MakeDistribution = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
`;

const MakeItem = styled.div`
  display: block;
  padding: 8px 10px;
  border-radius: 10px;
  background: #1E1E35;
  min-width: 110px;
  text-align: center;
`;

const MakeName = styled.span`
  display: block;
  color: #9E9E9E;
  font-weight: 500;
  font-size: 18px;
`;

const MakeCount = styled.span`
  display: block;
  color: #fff;
  font-weight: 600;
   font-size: 24px;
`;

const AppointmentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
`;

const AppointmentCard = styled.div`
  border-radius: 10px;
  background: #1E1E35;
  padding: 20px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
`;

const AppointmentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

const CustomerInfo = styled.div`
  flex: 1;
`;

const CustomerName = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  color: #ededed;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CustomerContact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 8px;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  color: #9E9E9E;
`;

const VehicleInfo2 = styled.div`
  font-size: 0.875rem;
  color: #9E9E9E;
  margin-bottom: 4px;
`;

const VehicleDetailsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;

const VehicleDetail = styled.span`
  background: rgba(255, 255, 255, 0.05);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  color: #9E9E9E;
`;

const AppointmentAmount = styled.div`
  text-align: right;
  min-width: 120px;
`;

const AmountValue = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: #F43F60;
  margin-bottom: 4px;
`;

const AmountLabel = styled.div`
  font-size: 0.75rem;
  color: #9E9E9E;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const AppointmentDate = styled.div`
  font-size: 0.875rem;
  color: #ededed;
  font-weight: 500;
  margin-bottom: 4px;
`;

const AppointmentTime = styled.div`
  font-size: 0.75rem;
  color: #9E9E9E;
  margin-bottom: 12px;
`;

const AppointmentStatus = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const StatusBadge = styled.div`
  background: ${props => {
    switch (props.status) {
      case 'scheduled': return 'rgba(16, 185, 129, 0.2)';
      case 'completed': return 'rgba(59, 130, 246, 0.2)';
      case 'cancelled': return 'rgba(239, 68, 68, 0.2)';
      default: return 'rgba(107, 114, 128, 0.2)';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'scheduled': return '#10B981';
      case 'completed': return '#3B82F6';
      case 'cancelled': return '#EF4444';
      default: return '#6B7280';
    }
  }};
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const AppointmentId = styled.div`
  font-size: 0.75rem;
  color: #9E9E9E;
  font-family: monospace;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #9E9E9E;
  font-size: 16px;
`;

const ErrorMessage = styled.div`
  color: #EF4444;
  text-align: center;
  padding: 40px 20px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 12px;
  font-size: 18px
`;

const LoadingMessage = styled.div`
  color: #9E9E9E;
  text-align: center;
  padding: 40px 20px;
`;

// New styled components for redesigned sections
const OfferCard = styled.div`
  border-radius: 10px;
  background: #1E1E35;
  box-shadow: 0 15px 15px 0 rgba(75, 75, 75, 0.08);
  padding: 20px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  @media (max-width: 767px) {
    padding: 10px;
  }

`;

const ScheduleCard = styled.div`
  border-radius: 10px;
  background: #1E1E35;
  box-shadow: 0 15px 15px 0 rgba(75, 75, 75, 0.08);
  padding: 20px;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  @media (max-width: 767px) {
    padding: 10px;
  }

`;

const CardHeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 16px;
  @media (max-width: 767px) {
    display: block;
  }
`;

const CardMainInfo = styled.div`
  flex: 1;
`;

const CardId = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CardVehicleInfo = styled.div`
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 4px;
`;

const CardStatus = styled.div`
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

const CardAmount = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1;
`;

const CardStatusBadge = styled.div`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: ${props => props.status === 'accepted' || props.status === 'scheduled' 
    ? 'linear-gradient(135deg, #10B981 0%, #059669 100%)' 
    : 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)'};
  color: #ffffff;
  box-shadow: 0 4px 12px ${props => props.status === 'accepted' || props.status === 'scheduled' 
    ? 'rgba(16, 185, 129, 0.3)' 
    : 'rgba(245, 158, 11, 0.3)'};
`;

const CardDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  transition: all 0.3s ease;
  
`;

const DetailLabel = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
  font-weight: 500;
`;

const DetailValue = styled.span`
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  font-family: ${props => props.monospace ? 'monospace' : 'inherit'};
  text-align: right;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ScheduleTimeInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  padding: 16px;
  background: #313151;
  border-radius: 12px;
`;

const TimeSlotItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
`;

const TimeSlotLabel = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  font-size: 16px;
`;

const TimeSlotValue = styled.span`
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
`;

// Collapsible card components
const CollapsibleCard = styled.div`
  background: #25253C;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 8px 10px;
  }
`;

const CollapsibleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.isExpanded ? '25px' : '0'};
  cursor: pointer;
  transition: all 0.3s ease;

`;

const CollapsibleTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.50);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  
  @media (min-width: 640px) {
    font-size: 18px;
  }
`;

const CollapsibleIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, ${props => props.bgColor || '#667eea'}20, ${props => props.bgColor || '#667eea'}10);
  color: ${props => props.bgColor || '#667eea'};
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
  
  @media (min-width: 640px) {
    width: 36px;
    height: 36px;
  }
`;

const CollapseButton = styled.button`
  background: #1E1E35;
  padding: 8px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: relative;
  overflow: hidden; 
  transition: all 0.3s ease;


  &:hover {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%);
    transition: all 0.3s ease;
  }
`;

const CollapsibleContent = styled.div`
  max-height: ${props => props.isExpanded ? '600px' : '0'};
  opacity: ${props => props.isExpanded ? '1' : '0'};
  overflow: hidden;
  overflow-y: auto;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform: translateY(${props => props.isExpanded ? '0' : '-20px'});
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  @media (max-width: 768px) {
    display: block;
  }
`;

const InfoSection = styled.div`
  border-radius: 10px;
  background: #1E1E35;
  box-shadow: 0 15px 15px 0 rgba(75, 75, 75, 0.08);
  padding: 20px;
  transition: all 0.3s ease;
  
`;

const InfoSectionTitle = styled.h4`
  margin: 0 0 16px 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const InfoItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  &:last-child {
    border-bottom: none;
  }
`;

const InfoLabel = styled.span`
  color: rgba(255, 255, 255, 0.6);
   font-size: 16px;
  font-weight: 500;
`;

const InfoValue = styled.span`
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  font-family: ${props => props.monospace ? 'monospace' : 'inherit'};
  text-align: right;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const AnalyticsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
`;

const VehicleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 24px;
`;

const VehicleDetailCard = styled.div`
  border-radius: 10px;
  background: #25253C;
  padding: 20px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
 
`;

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [dashboardData, setDashboardData] = useState({
    dealer: {},
    analytics: {},
    recentActivity: [],
    performanceMetrics: {},
    summary: {}
  });
  const [appointments, setAppointments] = useState([]);
  
  // Collapsible state management
  const [collapsedSections, setCollapsedSections] = useState({
    businessAnalytics: false,
    dealerInfo: false,
    performanceMetrics: false,
    recentActivity: false,
    vehicleMakes: false,
    recentVehicles: false,
    detailedVehicles: false,
    recentOffers: false,
    recentSchedules: false
  });

  const toggleSection = (sectionName) => {
    setCollapsedSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      setError('');
      try {
        const dashboardRes = await getDealerDashboard();
        console.log('Dealer Dashboard API Response:', dashboardRes);

        if (dashboardRes.status === 'success') {
          const data = dashboardRes.data || {};
          setDashboardData(data);

          const currentMonthStart = startOfMonth(new Date());
          const currentMonthEnd = endOfMonth(new Date());

          const appointmentsRes = await getDealerAppointments({
            startDate: format(currentMonthStart, 'yyyy-MM-dd'),
            endDate: format(currentMonthEnd, 'yyyy-MM-dd'),
          });

          if (appointmentsRes.status === 'success') {
            const appointmentsData = appointmentsRes.data.appointments || [];
            setAppointments(appointmentsData.slice(0, 5));
          }
        } else {
          setError(dashboardRes.message || 'Failed to fetch dashboard data');
        }
      } catch (err) {
        setError('Failed to fetch dashboard data');
        console.error('Dashboard data fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const formatActivityTime = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInHours = Math.floor((now - activityTime) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours} hours ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays} days ago`;
    
    return activityTime.toLocaleDateString();
  };

  const getActivityIcon = (type) => {
    switch (type) {
      case 'vehicle': return <Car size={16} />;
      case 'offer': return <DollarSign size={16} />;
      case 'schedule': return <Calendar size={16} />;
      case 'message': return <MessageSquare size={16} />;
      default: return <Car size={16} />;
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'vehicle': return '#0FC9A7';
      case 'offer': return '#8B5CF6';
      case 'schedule': return '#F43F60';
      case 'message': return '#F59E0B';
      default: return '#0FC9A7';
    }
  };

  const getActivityTitle = (activity) => {
    const { type, action, data } = activity;
    
    switch (type) {
      case 'vehicle':
        return action === 'added' ? 'Vehicle added to inventory' : 'Vehicle updated';
      case 'offer':
        return action === 'received' ? 'New offer received' : 'Offer updated';
      case 'schedule':
        return action === 'scheduled' ? 'Appointment scheduled' : 'Schedule updated';
      case 'message':
        return action === 'received' ? 'New message received' : 'Message sent';
      default:
        return 'Activity updated';
    }
  };

  const getActivityDescription = (activity) => {
    const { type, data } = activity;
    
    switch (type) {
      case 'vehicle':
        return `${data.year} ${data.make} ${data.model} - $${parseInt(data.price)?.toLocaleString()}`;
      case 'offer':
        return `Offer for ${data.vehicle?.year} ${data.vehicle?.make} ${data.vehicle?.model} - $${data.amount?.toLocaleString()}`;
      case 'schedule':
        if (data.date) {
          try {
            const scheduleDate = new Date(data.date);
            if (!isNaN(scheduleDate.getTime())) {
              return `Appointment scheduled for ${format(scheduleDate, 'MMM dd, yyyy')} at ${data.timeSlot?.start}`;
            }
          } catch (error) {
            console.error('Invalid date format:', data.date);
          }
        }
        return `Appointment scheduled for ${data.timeSlot?.start || 'TBD'}`;
      case 'message':
        return data.content || 'New message received';
      default:
        return 'Activity details';
    }
  };

  if (loading) {
    return (
      <Wrapper>
        <Container>
          <LoadingMessage>Loading dashboard data...</LoadingMessage>
        </Container>
      </Wrapper>
    );
  }

  if (error) {
    return (
      <Wrapper>
        <Container>
          <ErrorMessage>{error}</ErrorMessage>
        </Container>
      </Wrapper>
    );
  }

  const { dealer, analytics, performanceMetrics, summary } = dashboardData;
  const recentActivity = []; // Not available in new API response

  return (
    <Wrapper>
      <Container>
        {/* Hero Section */}
        <HeroSection>
          <HeroContent>
            <HeroInfo>   
              <div>
                <WelcomeTitle>Welcome back!</WelcomeTitle>
                <WelcomeSubtitle>Here's what's happening with your dealership today</WelcomeSubtitle>
              </div>
              <DealerBadge>
                <Building size={16} />
                {dealer.dealerInfo?.name || 'Dealer'}
              </DealerBadge>
            </HeroInfo>
            <QuickStats>
              <QuickStat> 
              <CarIcons style={{background: 'rgba(124, 192, 255, 0.10)'}}>
                  <Tags size={30} color='#7CC0FF' />
                </CarIcons>
                <CarCons>
                  <QuickStatValue>${(summary.averagePrice / 1000).toFixed(0)}k</QuickStatValue>
                  <QuickStatLabel>Avg Price</QuickStatLabel>
                </CarCons>
              </QuickStat>
              <QuickStat>              
              <CarIcons style={{background: 'rgba(124, 192, 255, 0.10)'}}>
                  <Tags size={30} color='#7CC0FF' />
                </CarIcons>
                <CarCons>
                  <QuickStatValue>${(summary.averagePrice / 1000).toFixed(0)}k</QuickStatValue>
                  <QuickStatLabel>Avg Price</QuickStatLabel>
                </CarCons>
              </QuickStat>
              <QuickStat>           
              <CarIcons style={{background: 'rgba(132, 255, 203, 0.10)'}}>
                  <Eye size={30} color='#3CC58C' />
                </CarIcons>
                <CarCons>
                  <QuickStatValue>{summary.totalViews}</QuickStatValue>
                  <QuickStatLabel>Views</QuickStatLabel>
                </CarCons>
              </QuickStat>
              <QuickStat>           
              <CarIcons style={{background: 'rgba(255, 116, 241, 0.15)'}}>
                  <BadgePercent size={30} color='#FF74F1' />
                </CarIcons>
                <CarCons>
                  <QuickStatValue>{summary.totalOffers}</QuickStatValue>
                  <QuickStatLabel>Offers</QuickStatLabel>
                </CarCons>
              </QuickStat>
              <QuickStat>
                <CarIcons style={{background: '#353F61'}}>
                  <CalendarMinus2 size={30} color='#7CC0FF' />
                </CarIcons>
                <CarCons>
                  <QuickStatValue>{summary.totalSchedules}</QuickStatValue>
                  <QuickStatLabel>Schedules</QuickStatLabel>
                </CarCons>
              </QuickStat>
            </QuickStats>
          </HeroContent>
        </HeroSection>

        {/* Main Dashboard Grid */}
        <MainGrid>
          {/* Vehicle Overview */}
          <LargeCard accentColor="#0FC9A7">
            <CardHeader>
              <CardTitle>
                <CardIcon bgColor="#0FC9A7">
                  <Car size={20} />
                </CardIcon>
                Vehicle Overview
              </CardTitle>
            </CardHeader>
            <StatsGrid>
              <StatItem>
               <GalleryVerticalEnd size={30} />
                <StatValue>{analytics.vehicles?.total || 0}</StatValue>
                <StatLabel>Total</StatLabel>
              </StatItem>
              <StatItem>
              <BadgeCheck size={30} />
                <StatValue>{analytics.vehicles?.byStatus?.Live || 0}</StatValue>
                <StatLabel>Live</StatLabel>
              </StatItem>
              <StatItem>
               <UsersRound size={30} />
                <StatValue>{analytics.vehicles?.byCondition?.Used || 0}</StatValue>
                <StatLabel>Used</StatLabel>
              </StatItem>
              <StatItem>
              <DollarSign size={30} />
                <StatValue>${analytics.vehicles?.averagePrice?.toLocaleString()}</StatValue>
                <StatLabel>Avg Price</StatLabel>
              </StatItem>
            </StatsGrid>
          </LargeCard>

          {/* Recent Activity */}
          <LargeCard accentColor="#8B5CF6">
            <CardHeader>
              <CardTitle>
                <CardIcon bgColor="#8B5CF6">
                  <Activity size={20} />
                </CardIcon>
                Recent Activity
              </CardTitle>
              <ViewMoreButton>
                View All
                <ChevronRight size={18} />
              </ViewMoreButton>
            </CardHeader>
            <ActivityList>
              {recentActivity && recentActivity.length > 0 ? (
                recentActivity.slice(0, 4).map((activity, index) => (
                  <ActivityItem key={index} accentColor={getActivityColor(activity.type)}>
                    <ActivityIcon bgColor={getActivityColor(activity.type)}>
                      {getActivityIcon(activity.type)}
                    </ActivityIcon>
                    <ActivityContent>
                      <ActivityTitle>{getActivityTitle(activity)}</ActivityTitle>
                      <ActivityTime>
                        {getActivityDescription(activity)} • {formatActivityTime(activity.timestamp)}
                      </ActivityTime>
                    </ActivityContent>
                  </ActivityItem>
                ))
              ) : (
                <EmptyState>No recent activity</EmptyState>
              )}
            </ActivityList>
          </LargeCard>

          {/* Make Distribution */}
          <LargeCard accentColor="#F59E0B">
            <CardHeader>
              <CardTitle>
                <CardIcon bgColor="#F59E0B">
                  <BarChart3 size={20} />
                </CardIcon>
                Vehicle Makes
              </CardTitle>
            </CardHeader>
            <MakeDistribution>
              {analytics.vehicles?.byMake?.slice(0, 6).map((make, index) => (
                <MakeItem key={index}>
                  <MakeCount>{make.count}</MakeCount>
                  <MakeName>{make._id}</MakeName>
                </MakeItem>
              ))}
            </MakeDistribution>
          </LargeCard>

          {/* Recent Vehicles */}
          <WideCard accentColor="#F43F60">
            <CardHeader>
              <CardTitle>
                <CardIcon bgColor="#F43F60">
                  <Car size={20} />
                </CardIcon>
                Recent Vehicles
              </CardTitle>
              <ViewMoreButton>
                View All
                <ChevronRight size={18} />
              </ViewMoreButton>
            </CardHeader>
            <VehicleList>
              {analytics.vehicles?.recent?.slice(0, 4).map((vehicle, index) => {
                // Parse images from imagelist string
                let images = [];
                try {
                  if (vehicle.imagelist && typeof vehicle.imagelist === 'string') {
                    images = JSON.parse(vehicle.imagelist);
                  }
                } catch (e) {
                  console.error('Error parsing imagelist:', e);
                }

                return (
                  <VehicleItem key={index}>
                    <VehicleImage>
                      {images && images.length > 0 ? (
                        <img 
                          src={images[0].url} 
                          alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : (
                        <Car size={20} />
                      )}
                    </VehicleImage>
                    <VehicleInfo>
                      <VehicleName>{vehicle.year} {vehicle.make} {vehicle.model} {vehicle.trim}</VehicleName>
                      <VehicleDetails>
                        {parseInt(vehicle.mileage)?.toLocaleString()} miles <Dotss>•</Dotss> {vehicle.transmission} <Dotss>•</Dotss> {vehicle.website_views || 0 } views
                      </VehicleDetails>
                      <div style={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: '8px', 
                        marginTop: '8px',
                        fontSize: '14px'
                      }}>
                        <span style={{ 
                          bbackground: '#1E1E35', 
                          padding: '2px 8px', 
                          borderRadius: '4px',
                          color: '#9E9E9E'
                        }}>
                          VIN: {vehicle.vin?.slice(-8)}
                        </span>
                        <span style={{ 
                          background: '#1E1E35', 
                          padding: '2px 8px', 
                          borderRadius: '4px',
                          color: '#9E9E9E'
                        }}>
                          {vehicle.engine}
                        </span>
                        <span style={{ 
                          background: '#1E1E35',
                          padding: '2px 8px', 
                          borderRadius: '4px',
                          color: '#9E9E9E'
                        }}>
                          {vehicle.drivetrain}
                        </span>
                        <span style={{ 
                          background: '#1E1E35',
                          padding: '2px 8px', 
                          borderRadius: '4px',
                          color: '#9E9E9E'
                        }}>
                          {vehicle.new_used}
                        </span>
                        {vehicle.certified === 'certified' && (
                          <span style={{ 
                            background: '#1E1E35',
                            padding: '2px 8px', 
                            borderRadius: '4px',
                            color: '#10B981'
                          }}>
                            Certified
                          </span>
                        )}
                      </div>
                    </VehicleInfo>
                    <VehiclePrice>
                      <div>
                        <div>
                          ${parseInt(vehicle.price)?.toLocaleString()}
                        </div>
                        {vehicle.msrp && (
                          <div style={{ fontSize: '14px', color: '#9E9E9E' }}>
                            MSRP: ${parseInt(vehicle.msrp)?.toLocaleString()}
                          </div>
                        )}
                      </div>
                    </VehiclePrice>
                  </VehicleItem>
                );
              })}
            </VehicleList>
          </WideCard>

          {/* Performance Metrics */}
          <LargeCard accentColor="#10B981">
            <CardHeader>
              <CardTitle>
                <CardIcon bgColor="#10B981">
                  <Target size={20} />
                </CardIcon>
                Performance
              </CardTitle>
            </CardHeader>
            {performanceMetrics && Object.keys(performanceMetrics).length > 0 ? (
              Object.entries(performanceMetrics)
                .filter(([key]) => !['averageResponseTime', 'inventoryTurnover', 'customerSatisfaction'].includes(key))
                .map(([key, value]) => (
                  <div key={key} style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    padding: '12px 0',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
                  }}>
                    <div style={{ fontSize: '16px', color: '#9E9E9E' }}>
                      {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                    </div>
                    <div style={{ fontSize: '1rem', fontWeight: '600', color: '#ededed' }}>
                      {typeof value === 'number' ? `${value}%` : value}
                    </div>
                  </div>
                ))
            ) : (
              <EmptyState>No performance data available</EmptyState>
            )}
          </LargeCard>
        </MainGrid>

        {/* Business Analytics */}
        <CollapsibleCard 
          accentColor="#6366F1" 
          accentColor2="#8B5CF6" 
          accentColor3="#A855F7"
        >
          <CollapsibleHeader 
            isExpanded={!collapsedSections.businessAnalytics}
            onClick={() => toggleSection('businessAnalytics')}
          >
            <CollapsibleTitle>
              <CollapsibleIcon bgColor="#6366F1">
                <BarChart3 size={20} />
              </CollapsibleIcon>
              Business Analytics
            </CollapsibleTitle>
            <CollapseButton>
              {collapsedSections.businessAnalytics ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
            </CollapseButton>
          </CollapsibleHeader>
          
          <CollapsibleContent isExpanded={!collapsedSections.businessAnalytics}>
            <AnalyticsGrid>
              <StatItem>
                <StatValue>{analytics.offers?.total || 0}</StatValue>
                <StatLabel>Total Offers</StatLabel>
              </StatItem>
              <StatItem>
                <StatValue>{analytics.offers?.last30Days || 0}</StatValue>
                <StatLabel>Last 30 Days</StatLabel>
              </StatItem>
              <StatItem>
                <StatValue>{analytics.offers?.last7Days || 0}</StatValue>
                <StatLabel>Last 7 Days</StatLabel>
              </StatItem>
              <StatItem>
                <StatValue>{analytics.schedules?.total || 0}</StatValue>
                <StatLabel>Total Schedules</StatLabel>
              </StatItem>
              <StatItem>
                <StatValue>{analytics.schedules?.last30Days || 0}</StatValue>
                <StatLabel>Last 30 Days</StatLabel>
              </StatItem>
              <StatItem>
                <StatValue>{summary.totalViews || 0}</StatValue>
                <StatLabel>Total Views</StatLabel>
              </StatItem>
            </AnalyticsGrid>
          </CollapsibleContent>
        </CollapsibleCard>

        {/* Dealer Information */}
        <CollapsibleCard 
          accentColor="#10B981" 
          accentColor2="#059669" 
          accentColor3="#047857"
        >
          <CollapsibleHeader 
            isExpanded={!collapsedSections.dealerInfo}
            onClick={() => toggleSection('dealerInfo')}
          >
            <CollapsibleTitle>
              <CollapsibleIcon bgColor="#10B981">
                <Building size={20} />
              </CollapsibleIcon>
              Dealer Information
            </CollapsibleTitle>
            <CollapseButton>
              {collapsedSections.dealerInfo ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
            </CollapseButton>
          </CollapsibleHeader>
          
          <CollapsibleContent isExpanded={!collapsedSections.dealerInfo}>
            <InfoGrid>
              <InfoSection>
                <InfoSectionTitle>
                  <Building size={16} />
                  Basic Info
                </InfoSectionTitle>
                <InfoItem>
                  <InfoLabel>Dealer ID</InfoLabel>
                  <InfoValue monospace>{dealer.id}</InfoValue>
                </InfoItem>
                <InfoItem>
                  <InfoLabel>Name</InfoLabel>
                  <InfoValue>{dealer.name}</InfoValue>
                </InfoItem>
                <InfoItem>
                  <InfoLabel>Email</InfoLabel>
                  <InfoValue>{dealer.email}</InfoValue>
                </InfoItem>
                <InfoItem>
                  <InfoLabel>Phone</InfoLabel>
                  <InfoValue>{dealer.dealerInfo?.phone}</InfoValue>
                </InfoItem>
                <InfoItem>
                  <InfoLabel>Name</InfoLabel>
                  <InfoValue style={{ textTransform: 'capitalize' }}>{dealer.dealerInfo?.name}</InfoValue>
                </InfoItem>
                <InfoItem>
                  <InfoLabel>Phone</InfoLabel>
                  <InfoValue>{dealer.dealerInfo?.phone}</InfoValue>
                </InfoItem>
              </InfoSection>
              
              <InfoSection>
                <InfoSectionTitle>
                  <MapPin size={16} />
                  Address
                </InfoSectionTitle>
                <InfoItem>
                  <InfoLabel>Street</InfoLabel>
                  <InfoValue>{dealer.dealerInfo?.street || 'N/A'}</InfoValue>
                </InfoItem>
                <InfoItem>
                  <InfoLabel>City, State, ZIP</InfoLabel>
                  <InfoValue>
                    {dealer.dealerInfo?.city}, {dealer.dealerInfo?.state} {dealer.dealerInfo?.zip}
                  </InfoValue>
                </InfoItem>
                <InfoItem>
                  <InfoLabel>Coordinates</InfoLabel>
                  <InfoValue monospace>
                    {dealer.dealerInfo?.latitude}, {dealer.dealerInfo?.longitude}
                  </InfoValue>
                </InfoItem>
              </InfoSection>
              

            </InfoGrid>
          </CollapsibleContent>
        </CollapsibleCard>

        {/* Recent Offers Details */}
        <CollapsibleCard 
          accentColor="#8B5CF6" 
          accentColor2="#A855F7" 
          accentColor3="#C084FC"
        >
          <CollapsibleHeader 
            isExpanded={!collapsedSections.recentOffers}
            onClick={() => toggleSection('recentOffers')}
          >
            <CollapsibleTitle>
              <CollapsibleIcon bgColor="#8B5CF6">
                <DollarSign size={20} />
              </CollapsibleIcon>
              Recent Offers Details
            </CollapsibleTitle>
            <CollapseButton>
              {collapsedSections.recentOffers ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
            </CollapseButton>
          </CollapsibleHeader>
          
          <CollapsibleContent isExpanded={!collapsedSections.recentOffers}>
          {analytics.offers?.recent && analytics.offers.recent.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', 'flexWrap': ' wrap' }}>
              {analytics.offers.recent.map((offer, index) => (
                <OfferCard key={index}>
                  <CardHeaderSection>
                    <CardMainInfo>
                      <CardId>
                        <DollarSign size={16} />
                        Offer ID: {offer._id?.slice(-8)}
                      </CardId>
                      <CardVehicleInfo>
                        {offer.vehicle?.year} {offer.vehicle?.make} {offer.vehicle?.model}
                      </CardVehicleInfo>
                    </CardMainInfo>
                    <CardStatus>
                      <CardAmount>
                        ${offer.amount?.toLocaleString()}
                      </CardAmount>
                      <CardStatusBadge status={offer.status}>
                        {offer.status}
                      </CardStatusBadge>
                    </CardStatus>
                  </CardHeaderSection>
                  
                  <CardDetailsGrid>
                    <DetailItem>
                      <DetailLabel>Vehicle ID</DetailLabel>
                      <DetailValue monospace>{offer.vehicle?._id}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>Stock ID</DetailLabel>
                      <DetailValue>{offer.vehicle?.stockId}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>VIN</DetailLabel>
                      <DetailValue monospace>{offer.vehicle?.vin}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>Asking Price</DetailLabel>
                      <DetailValue>${parseInt(offer.vehicle?.price)?.toLocaleString()}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>User ID</DetailLabel>
                      <DetailValue monospace>{offer.user?._id}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>Created</DetailLabel>
                      <DetailValue>{new Date(offer.createdAt).toLocaleString()}</DetailValue>
                    </DetailItem>
                  </CardDetailsGrid>
                </OfferCard>
              ))}
            </div>
          ) : (
            <EmptyState>No recent offers available</EmptyState>
          )}
          </CollapsibleContent>
        </CollapsibleCard>

        {/* Recent Schedules Details */}
        <CollapsibleCard 
          accentColor="#F43F60" 
          accentColor2="#EF4444" 
          accentColor3="#F87171"
        >
          <CollapsibleHeader 
            isExpanded={!collapsedSections.recentSchedules}
            onClick={() => toggleSection('recentSchedules')}
          >
            <CollapsibleTitle>
              <CollapsibleIcon bgColor="#F43F60">
                <Calendar size={20} />
              </CollapsibleIcon>
              Recent Schedules Details
            </CollapsibleTitle>
            <CollapseButton>
              {collapsedSections.recentSchedules ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
            </CollapseButton>
          </CollapsibleHeader>
          
          <CollapsibleContent isExpanded={!collapsedSections.recentSchedules}>
          {analytics.schedules?.recent && analytics.schedules.recent.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {analytics.schedules.recent.map((schedule, index) => (
                <ScheduleCard key={index}>
                  <CardHeaderSection>
                    <CardMainInfo>
                      <CardId>
                        <Calendar size={16} />
                        Schedule ID: {schedule._id?.slice(-8)}
                      </CardId>
                      <CardVehicleInfo>
                        {schedule.offer?.vehicle?.year} {schedule.offer?.vehicle?.make} {schedule.offer?.vehicle?.model}
                      </CardVehicleInfo>
                    </CardMainInfo>
                    <CardStatus>
                      <CardStatusBadge status={schedule.status}>
                        {schedule.status}
                      </CardStatusBadge>
                    </CardStatus>
                  </CardHeaderSection>
                  
                  <CardDetailsGrid>
                    <DetailItem>
                      <DetailLabel>Offer ID</DetailLabel>
                      <DetailValue monospace>{schedule.offer?._id}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>Vehicle ID</DetailLabel>
                      <DetailValue monospace>{schedule.offer?.vehicle?._id}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>Stock ID</DetailLabel>
                      <DetailValue>{schedule.offer?.vehicle?.stockId}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>VIN</DetailLabel>
                      <DetailValue monospace>{schedule.offer?.vehicle?.vin}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>Offer Amount</DetailLabel>
                      <DetailValue>${schedule.offer?.amount?.toLocaleString()}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>Dealer ID</DetailLabel>
                      <DetailValue monospace>{schedule.offer?.dealer}</DetailValue>
                    </DetailItem>
                    <DetailItem>
                      <DetailLabel>Created</DetailLabel>
                      <DetailValue>{new Date(schedule.createdAt).toLocaleString()}</DetailValue>
                    </DetailItem>
                  </CardDetailsGrid>
                  
                  <ScheduleTimeInfo>
                    <TimeSlotItem>
                      <TimeSlotLabel>Date</TimeSlotLabel>
                      <TimeSlotValue>{new Date(schedule.date).toLocaleDateString()}</TimeSlotValue>
                    </TimeSlotItem>
                    <TimeSlotItem>
                      <TimeSlotLabel>Time Slot</TimeSlotLabel>
                      <TimeSlotValue>{schedule.timeSlot?.start} - {schedule.timeSlot?.end}</TimeSlotValue>
                    </TimeSlotItem>
                  </ScheduleTimeInfo>
                </ScheduleCard>
              ))}
            </div>
          ) : (
            <EmptyState>No recent schedules available</EmptyState>
          )}
          </CollapsibleContent>
        </CollapsibleCard>



        {/* Detailed Vehicle Information */}
        <CollapsibleCard 
          accentColor="#0FC9A7" 
          accentColor2="#10B981" 
          accentColor3="#059669"
        >
          <CollapsibleHeader 
            isExpanded={!collapsedSections.detailedVehicles}
            onClick={() => toggleSection('detailedVehicles')}
          >
            <CollapsibleTitle>
              <CollapsibleIcon bgColor="#0FC9A7">
                <Car size={20} />
              </CollapsibleIcon>
              Detailed Vehicle Information
            </CollapsibleTitle>
            <CollapseButton>
              {collapsedSections.detailedVehicles ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
            </CollapseButton>
          </CollapsibleHeader>
          
          <CollapsibleContent isExpanded={!collapsedSections.detailedVehicles}>
          {analytics.vehicles?.recent && analytics.vehicles.recent.length > 0 ? (
            <div className='customcards' style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {analytics.vehicles.recent.map((vehicle, index) => {
                // Parse images from imagelist string
                let images = [];
                try {
                  if (vehicle.imagelist && typeof vehicle.imagelist === 'string') {
                    images = JSON.parse(vehicle.imagelist);
                  }
                } catch (e) {
                  console.error('Error parsing imagelist:', e);
                }

                return (
                <div key={index} style={{
                  background: '#1E1E35',
                  borderRadius: '10px',
                  padding: '20px',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                  
                  <div className='displyblock' style={{ display: 'flex', gap: '20px', marginBottom: '16px' }}>
                    <div style={{ 
                      width: '120px', 
                      height: '80px', 
                      background: 'rgba(255, 255, 255, 0.05)',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      marginBottom: '10px'
                    }}>
                      {images && images.length > 0 ? (
                        <img 
                          src={images[0].url} 
                          alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : (
                        <Car size={32} color="#9E9E9E" />
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div className='displyblock' style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'flex-start',
                        marginBottom: '8px'
                      }}>
        <div>
                          <h3 style={{ 
                            margin: '0 0 4px 0', 
                            color: '#ededed', 
                            fontSize: '20px',
                            fontWeight: '600'
                          }}>
                            {vehicle.year} {vehicle.make} {vehicle.model} {vehicle.trim}
                          </h3>
                          <div style={{ color: '#9E9E9E', fontSize: '15px' }}>
                            Stock ID: {vehicle.stock_no} <Dotss> • </Dotss> VIN: {vehicle.vin}
                          </div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ fontSize: '1.5rem', fontWeight: '600', color: '#0FC9A7' }}>
                            ${parseInt(vehicle.price)?.toLocaleString()}
                          </div>
                          {vehicle.msrp && (
                            <div style={{ fontSize: '15px', color: '#9E9E9E' }}>
                              MSRP: ${parseInt(vehicle.msrp)?.toLocaleString()}
                            </div>
                          )}
                        </div>
                      </div>
                      
                      <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                        gap: '16px',
                        marginBottom: '16px'
                      }}>
                        <div>
                          <h4 style={{ margin: '0 0 8px 0', color: '#ededed', fontSize: '1rem' }}>Specifications</h4>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '0.875rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Engine:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{vehicle.engine}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Transmission:</span>
                              <span style={{ color: '#ededed', textTransform: 'capitalize', fontSize: '16px' }}>{vehicle.transmission}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Drive Train:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{vehicle.drivetrain}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Mileage:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{parseInt(vehicle.mileage)?.toLocaleString()} miles</span>
                            </div>
                          </div>
                        </div>
                        
                        <div>
                          <h4 style={{ margin: '0 0 8px 0', color: '#ededed', fontSize: '1rem' }}>Pricing</h4>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '0.875rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Asking Price:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>${parseInt(vehicle.price)?.toLocaleString()}</span>
                            </div>
                            {vehicle.msrp && (
                              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ color: '#9E9E9E', fontSize: '16px' }}>MSRP:</span>
                                <span style={{ color: '#ededed', fontSize: '16px' }}>${parseInt(vehicle.msrp)?.toLocaleString()}</span>
                              </div>
                            )}
                            {vehicle.invoice_amount && (
                              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Invoice Amount:</span>
                                <span style={{ color: '#ededed', fontSize: '16px' }}>${parseInt(vehicle.invoice_amount)?.toLocaleString()}</span>
                              </div>
                            )}
                          </div>
                        </div>
                        
                        <div>
                          <h4 style={{ margin: '0 0 8px 0', color: '#ededed', fontSize: '1rem' }}>Details</h4>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '0.875rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E' }}>Status:</span>
                              <span style={{ 
                                color: vehicle.status === 'Live' ? '#10B981' : '#F59E0B',
                                textTransform: 'capitalize',
                                fontWeight: '600'
                              }}>
                                {vehicle.status}
                              </span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Condition:</span>
                              <span style={{ color: '#ededed', textTransform: 'capitalize', fontSize: '16px' }}>
                                {vehicle.new_used}
                              </span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Certified:</span>
                              <span style={{ fontSize: '16px', color: vehicle.certified === 'certified' ? '#10B981' : '#9E9E9E' }}>
                                {vehicle.certified === 'certified' ? 'Yes' : 'No'}
                              </span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Views:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{vehicle.website_views || 0}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                        gap: '16px',
                        marginBottom: '16px'
                      }}>
                        <div>
                          <h4 style={{ margin: '0 0 8px 0', color: '#ededed', fontSize: '1rem' }}>Fuel Economy</h4>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '0.875rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>City MPG:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{vehicle.mpg_city || 'N/A'}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Highway MPG:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{vehicle.mpg || 'N/A'}</span>
                            </div>
                          </div>
                        </div>
                        
                        <div>
                          <h4 style={{ margin: '0 0 8px 0', color: '#ededed', fontSize: '1rem' }}>Colors</h4>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '0.875rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>External:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{vehicle.ext_color || 'N/A'}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Interior:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{vehicle.int_color || 'N/A'}</span>
                            </div>
                          </div>
                        </div>
                        
                        <div>
                          <h4 style={{ margin: '0 0 8px 0', color: '#ededed', fontSize: '1rem' }}>Images</h4>
                          <div style={{ fontSize: '0.875rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Total Images:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{images?.length || 0}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                        gap: '16px',
                        marginBottom: '16px'
                      }}>
                        <div>
                          <h4 style={{ margin: '0 0 8px 0', color: '#ededed', fontSize: '1rem' }}>Timeline</h4>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '0.875rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Date In Stock:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>
                                {vehicle.date_in_stock ? new Date(vehicle.date_in_stock).toLocaleDateString() : 'N/A'}
                              </span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Created:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>
                                {vehicle.created ? new Date(vehicle.created).toLocaleDateString() : 'N/A'}
                              </span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Updated:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>
                                {vehicle.updated ? new Date(vehicle.updated).toLocaleDateString() : 'N/A'}
                              </span>
                            </div>
                          </div>
                        </div>
                        
                        <div>
                          <h4 style={{ margin: '0 0 8px 0', color: '#ededed', fontSize: '1rem' }}>Metadata</h4>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '0.875rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Data Source:</span>
                              <span style={{ color: '#ededed', textTransform: 'capitalize', fontSize: '16px' }}>{vehicle.source || 'N/A'}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>Website Status:</span>
                              <span style={{ color: '#ededed', textTransform: 'capitalize', fontSize: '16px' }}>{vehicle.website_status || 'N/A'}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#9E9E9E', fontSize: '16px' }}>VDP Clicks:</span>
                              <span style={{ color: '#ededed', fontSize: '16px' }}>{vehicle.vdp_clicks || 0}</span>
                            </div>
                          </div>
                        </div>
                        
                        <div>
                          <h4 style={{ margin: '0 0 8px 0', color: '#ededed', fontSize: '1rem' }}>Description</h4>
                          <div style={{ 
                            background: 'rgba(255, 255, 255, 0.05)', 
                            padding: '8px', 
                            borderRadius: '6px',
                            fontSize: '16px',
                            color: '#ededed'
                          }}>
                            {vehicle.description || 'No description available'}
                          </div>
                        </div>
                      </div>
                      

                    </div>
                  </div>
                </div>
              );
            })}
            </div>
          ) : (
            <EmptyState>No recent vehicles available</EmptyState>
          )}
          </CollapsibleContent>
        </CollapsibleCard>

        {/* Recent Appointments */}
        <CollapsibleCard 
          accentColor="#6366F1" 
          accentColor2="#8B5CF6" 
          accentColor3="#A855F7"
        >
          <CollapsibleHeader 
            isExpanded={!collapsedSections.recentActivity}
            onClick={() => toggleSection('recentActivity')}
          >
            <CollapsibleTitle>
              <CollapsibleIcon bgColor="#6366F1">
                <Calendar size={20} />
              </CollapsibleIcon>
              Recent Appointments
            </CollapsibleTitle>
            <CollapseButton>
              {collapsedSections.recentActivity ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
            </CollapseButton>
          </CollapsibleHeader>
          
          <CollapsibleContent isExpanded={!collapsedSections.recentActivity}>
          {appointments.length > 0 ? (
            <AppointmentGrid>
                            {appointments.map((appointment, index) => (
                <AppointmentCard key={index}>
                  <AppointmentHeader>
                    <CustomerInfo>
                      <CustomerName>
                        <Users size={16} />
                        {appointment.offer?.user?.userInfo?.name || 'Customer'}
                      </CustomerName>
                      <CustomerContact>
                        <ContactItem>
                          <Phone size={12} />
                          {appointment.offer?.user?.userInfo?.phone || 'No phone'}
                        </ContactItem>
                        <ContactItem>
                          <Globe size={12} />
                          {appointment.offer?.user?.userInfo?.email || 'No email'}
                        </ContactItem>
                      </CustomerContact>
                      <VehicleInfo2>
                        <Car size={14} />
                        {appointment.offer?.vehicle?.year} {appointment.offer?.vehicle?.make} {appointment.offer?.vehicle?.model}
                      </VehicleInfo2>
                      <VehicleDetailsGrid>
                        <VehicleDetail>VIN: {appointment.offer?.vehicle?.vin || 'N/A'}</VehicleDetail>
                        {appointment.offer?.vehicle?.images && appointment.offer.vehicle.images.length > 0 && (
                          <VehicleDetail>{appointment.offer.vehicle.images.length} images</VehicleDetail>
                        )}
                      </VehicleDetailsGrid>
                    </CustomerInfo>
                    <AppointmentAmount>
                      <AmountValue>${appointment.offer?.amount?.toLocaleString()}</AmountValue>
                      <AmountLabel>Offer Amount</AmountLabel>
                    </AppointmentAmount>
                  </AppointmentHeader>
                  
                  <AppointmentDate>
                    <Calendar size={14} />
                    {appointment.date ? format(new Date(appointment.date), 'EEEE, MMMM dd, yyyy') : 'Date not available'}
                  </AppointmentDate>
                  <AppointmentTime>
                    <Clock size={12} />
                    {appointment.timeSlot?.start} - {appointment.timeSlot?.end} ({appointment.timeSlot?.start && appointment.timeSlot?.end ? 
                      `${Math.abs(new Date(`2000-01-01T${appointment.timeSlot.end}`) - new Date(`2000-01-01T${appointment.timeSlot.start}`)) / (1000 * 60)} minutes` : 'Duration TBD'}
                    )
                  </AppointmentTime>
                  
                  <AppointmentStatus>
                    <StatusBadge status={appointment.status}>
                      {appointment.status}
                    </StatusBadge>
                    <AppointmentId>
                      ID: {appointment._id?.slice(-8)}
                    </AppointmentId>
                  </AppointmentStatus>
                </AppointmentCard>
              ))}
            </AppointmentGrid>
          ) : (
            <EmptyState>No appointments found for this month</EmptyState>
          )}
          </CollapsibleContent>
        </CollapsibleCard>
      </Container>
    </Wrapper>
  );
};

export default Dashboard;